module.exports = __webpack_public_path__ + "static/img/3areaA_20.0897a22.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/3areaA_20.png
// module id = 952
// module chunks = 1